import { useState, useEffect } from "react";

import "./DashboardFormGrid.css";
import '/src/components/UI/Button/IconButton/IconButton.css'
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import CheckBox from '/src/components/UI/CheckBox/CheckBox';
import DashboardCell from "../DashboardCell";

function DashboardFormGrid({ _cells, data, setGrid }) {

    const [cells, setCells] = useState(_cells?.rows?.length > 0 || _cells?.columns?.length > 0 ? _cells : { rows: [], columns: [], cells: [] });
    const addColumn = () => {
        let newColumn = {
            index: Date.now(),
            value: ""
        }
        let newCells = cells.cells;

        for (let i = 0; i < cells.rows.length; i++) {
            let newCell = { value: null, active: null };
            let index = cells.columns.length * (i+1) + i
            newCells.splice(index, 0, newCell);
        } 
        
        setCells({ rows: cells.rows, columns: [...cells.columns, newColumn], cells:  newCells})//cells.cells });
    }
    const addRow = () => {
        let newRow = {
            index: Date.now(),
            value: ""
        }
        let newCells = cells.cells;

        for (let i = 0; i < cells.columns.length; i++) {
            let newCell = { value: null, active: null };
            newCells.push(newCell);
        } 
        console.log(newCells);
        console.log("-----")
        setCells({ rows: [...cells.rows, newRow], columns: cells.columns, cells: newCells});
    }

    const removeRow = (_index, _i) => {
        let newArrayCells = cells.cells;
        let index = _i *cells.columns.length;
        for (let i = 0; i< cells.columns.length; i++){
            newArrayCells.splice(index,1)
        }
        console.log(newArrayCells)
        setCells({
            rows: [...cells.rows.filter((row) => row.index != _index)],
            columns: cells.columns,
            cells: newArrayCells
        })
    }

    const removeColumn = (_index, j) => {
        console.log(cells.cells);
        let newArrayCells = cells.cells;
        let arrayIndexRemoved = [];
        for (let i = 0; i < cells.cells.length; i++) {
            if (i % (cells.columns.length) != j) continue;
            arrayIndexRemoved.push(i);
        }
        for (let i = arrayIndexRemoved.length - 1; i >= 0; i--) {
            newArrayCells.splice(arrayIndexRemoved[i], 1);
        }

        setCells({
            rows: cells.rows,
            columns: [...cells.columns.filter((column) => column.index != _index)],
            cells: newArrayCells
        })
    }

    const modifyValue = (index, value) => {
        let rows = cells.rows;
        let columns = cells.columns
        for (let i = 0; i < rows.length; i++) {
            if (rows[i].index == index) {
                rows[i].value = value;
            }
        }
        for (let i = 0; i < columns.length; i++) {
            if (columns[i].index == index) {
                columns[i].value = value;
            }
        }
        setCells({ rows: rows, columns: columns, cells: cells.cells })
    }

    useEffect(() => {
        setGrid(cells);
    }, [cells])
    return (
        <div className="gridDashboard_main_container">
            <div className="dashboard_grid_column">
                <div className={"root_cell " + (cells.length > 0 ? "" : "single_root")} />
                {
                    cells.columns.map((cell, i) => {
                        return (
                            <div>
                                < div className="dashboard_column_remove" > <i className="fas fa-trash dashboard_remove_cell" aria-hidden="true" onClick={() => removeColumn(cell.index, i)}></i></div>
                                <DashboardCell data={cell} className={"dashboard_column_cell"} postbackAction={(index, value) => modifyValue(index, value)}></DashboardCell>
                            </div>
                        )
                    })
                }
                <div className="dashboard_column_add"><i className="fas fa-plus dashboard_add_cell" aria-hidden="true" onClick={() => addColumn()}></i></div>
            </div>
            <div className="rows">
                {
                    cells.rows.map((cell, i) => {
                        return (
                            <div style={{ display: "flex" }}>

                                < div className="dashboard_row_remove" > <i className="fas fa-trash dashboard_remove_cell" aria-hidden="true" onClick={() => removeRow(cell.index, i)}></i></div>
                                < DashboardCell data={cell} className={"dashboard_row_cell"} postbackAction={(index, value) => modifyValue(index, value)}></DashboardCell>
                                {cells.columns.map((cell, i) => {
                                    return (
                                        <div className="cell_border_grid"> </div>
                                    )
                                })}
                            </div>
                        )
                    })
                }

                < div className="dashboard_row_add" > <i className="fas fa-plus dashboard_add_cell" aria-hidden="true" onClick={() => addRow()}></i></div>
            </div>
        </div >

    );
}

export default DashboardFormGrid;